var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_43202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.461426C12.8355 0.461426 9.74207 1.39981 7.11088 3.15791C4.4797 4.91601 2.42894 7.41487 1.21793 10.3385C0.00693251 13.2621 -0.309921 16.4792 0.307443 19.5829C0.924806 22.6866 2.44866 25.5375 4.6863 27.7751C6.92394 30.0128 9.77487 31.5366 12.8786 32.154C15.9823 32.7714 19.1993 32.4545 22.1229 31.2435C25.0466 30.0325 27.5454 27.9817 29.3035 25.3506C31.0616 22.7194 32 19.6259 32 16.4614C32 12.218 30.3143 8.1483 27.3137 5.14772C24.3131 2.14714 20.2435 0.461426 16 0.461426V0.461426ZM11.3474 24.8825H7.85685V13.6383H11.3474V24.8825ZM9.60001 12.1035C9.19829 12.1052 8.80511 11.9877 8.47014 11.766C8.13518 11.5442 7.87348 11.2281 7.71812 10.8577C7.56276 10.4872 7.52071 10.079 7.5973 9.68466C7.67388 9.29031 7.86566 8.92752 8.14839 8.64214C8.43112 8.35676 8.79211 8.16161 9.18573 8.08135C9.57934 8.00109 9.98792 8.03933 10.3598 8.19123C10.7317 8.34313 11.0502 8.60187 11.2751 8.93476C11.4999 9.26764 11.6211 9.65971 11.6232 10.0614C11.6243 10.6001 11.4121 11.1173 11.033 11.5C10.6539 11.8826 10.1387 12.0996 9.60001 12.1035V12.1035ZM24.4211 24.8825H20.9326V19.4088C20.9326 18.1035 20.9074 16.4298 19.1179 16.4298C17.3284 16.4298 17.0126 17.8488 17.0126 19.3141V24.8825H13.5368V13.6383H16.8863V15.1709H16.9347C17.4 14.2867 18.539 13.3541 20.2379 13.3541C23.7705 13.3541 24.4211 15.6825 24.4211 18.7056V24.8825Z",
    fill: "white",
    fillOpacity: 0.68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_43202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.461426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin-1.95f9ca1411ee54a7d5d73c3175a68345.svg";
export { ForwardRef as ReactComponent };